import React from "react";

export default function Spinner({
  size = 14,
  color = "#ffffff",
  trackColor = "rgba(255, 255, 255, 0.35)",
  thickness = 2,
  style = {},
}) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `${thickness}px solid ${trackColor}`,
        borderTopColor: color,
        animation: "spin 1s linear infinite",
        display: "inline-block",
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
